var logout = (function( $ ) {

	var _init = function() {
		$( 'a.multireg-logout' ).on( 'click', _logout );
	};

	var _logout = function( e ) {
		$.post( ScriptData.ajaxurl, 'action=logout',function(data) {
			jQuery.removeCookie( 'bust_cache', { path: '/' } );

			jQuery.cookie( 'login_credentials', null );
			window.location.href = ScriptData.logout_redirect;
		});
		e.preventDefault();
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = logout;